import { DISMISS_NOTIFICATION } from 'actions/ActionTypes';

export function dismissNotification(payload) {
    return {
        type: DISMISS_NOTIFICATION,
        payload
    };
}
